export default "__VITE_ASSET__CnCisCCY__"